class SmsCounter {
  static gsm7bitChars: string = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";

  static gsm7bitExChar: string = "\\^{}\\\\\\[~\\]|€";

  static gsm7bitRegExp: RegExp = new RegExp("^[" + SmsCounter.gsm7bitChars + "]*$");

  static gsm7bitExRegExp: RegExp = new RegExp("^[" + SmsCounter.gsm7bitChars + SmsCounter.gsm7bitExChar + "]*$");

  static gsm7bitExOnlyRegExp: RegExp = new RegExp("^[\\" + SmsCounter.gsm7bitExChar + "]*$");

  static GSM_7BIT: string = 'GSM_7BIT';

  static GSM_7BIT_EX: string = 'GSM_7BIT_EX';

  static UTF16: string = 'UTF16';

  static messageLength: { [key: string]: number } = {
    GSM_7BIT: 160,
    GSM_7BIT_EX: 160,
    UTF16: 70
  };

  static multiMessageLength: { [key: string]: number } = {
    GSM_7BIT: 153,
    GSM_7BIT_EX: 153,
    UTF16: 67
  };

  static secondMultiMessageLength: { [key: string]: number } = {
    GSM_7BIT: 145,
    GSM_7BIT_EX: 145,
    UTF16: 63
  };

  static count(text: string): { encoding: string, length: number, per_message: number, remaining: number, messages: number } {
    let encoding: string = this.detectEncoding(text);
    let length: number = text.length;
    if (encoding === this.GSM_7BIT_EX) {
      length += this.countGsm7bitEx(text);
    }
    let per_message: number = this.messageLength[encoding];
    if (length > per_message) {
      per_message = this.multiMessageLength[encoding];
    }
    let messages: number = Math.ceil(length / per_message);

    let remaining: number = (per_message * messages) - length;
    if (remaining === 0 && messages === 0) {
      remaining = per_message;
    }

    // handling when second message only it have different max length with other
    if (messages === 2) {
      per_message = this.secondMultiMessageLength[encoding]
    }

    return {
      encoding: encoding,
      length: length,
      per_message: per_message,
      remaining: remaining,
      messages: messages
    };
  }

  static detectEncoding(text: string): string {
    if (text.match(this.gsm7bitRegExp)) {
      return this.GSM_7BIT;
    } else if (text.match(this.gsm7bitExRegExp)) {
      return this.GSM_7BIT_EX;
    } else {
      return this.UTF16;
    }
  }

  static countGsm7bitEx(text: string): number {
    let chars: string[] = [];
    for (let i = 0; i < text.length; i++) {
      let char2: string = text[i];
      if (char2.match(this.gsm7bitExOnlyRegExp)) {
        chars.push(char2);
      }
    }
    return chars.length;
  }
}

export default SmsCounter;
